export default __webpack_public_path__ + "media/images/brighteon-social/tutorial/Brighteon-Social-New-Post-Warning-1985294026d436284deee3aa46a76c94.png";